import { createContext } from "react";

export const TwitchAuthContext = createContext(null);
export const TwitchContextContext = createContext(null);
export const TwitchBroadcastContext = createContext(null);
export const TwitchChannelContext = createContext(null);
export const TwitchBitsContext = createContext({
  products: [],
});
export const GameVersionContext = createContext(null);
export const FollowerVariationPreviewsContext = createContext(null);
export const TimersContext = createContext(null);
